<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>

        <div class="table-responsive" style="max-height: 500px; overflow: auto;">
            <table mat-table [dataSource]="dataSource" matSort style="min-width:1759px;" #sort1="matSort">
                <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 1em; width: 1em;">
                        <mat-checkbox color="primary"
                            (change)="$event ? isAllSelected ? onClickAllClear() : onClickAllCheck() : null;"
                            [checked]="selection.hasValue() && isAllSelected"
                            [indeterminate]="selection.hasValue() && !isAllSelected">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox color="primary" (change)="$event ? this.selection.toggle(row) : null;"
                            [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="resumeClsfy">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 185px;">再開種別</th>
                    <td mat-cell *matCellDef="let row; let i = index">
                        <mat-select autocomplete="off" [(ngModel)]="row.resumeClsfy.codeValue"
                            [ngModelOptions]="{standalone: true}" class="disabled-select-color"
                            (valueChange)="onChangeResumeClsfy($event,row)" id="resumeClsfy">
                            <mat-option [value]="null"></mat-option>
                            <mat-option *ngFor="let type of resumeClsfyList"
                                [value]="type.value">{{type.viewValue}}</mat-option>
                        </mat-select>
                    </td>
                </ng-container>
                <ng-container matColumnDef="base">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 160px; max-width: 315px;">拠点</th>
                    <td mat-cell *matCellDef=" let row; let i=index">
                        <mat-select autocomplete="off" [(ngModel)]="row.base.codeValue"
                            [ngModelOptions]="{standalone: true}" class="disabled-select-color"
                            [disabled]="!['11','12',].includes(row.resumeClsfy.codeValue)"
                            (valueChange)="onChangeBase($event,row)" id="base" style="max-width: 315px;">
                            <mat-option *ngFor="let type of row.baseList"
                                [value]="type.value">{{type.viewValue}}</mat-option>
                        </mat-select>
                    </td>
                </ng-container>
                <ng-container matColumnDef="workTntsh">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 105px; max-width: 175px;">作業担当者</th>
                    <td mat-cell *matCellDef="let row; let i = index">
                        <mat-select autocomplete="off" [(ngModel)]="row.workTntsh.codeValue"
                            [ngModelOptions]="{standalone: true}" class="disabled-select-color"
                            [disabled]="!['11','12',].includes(row.resumeClsfy.codeValue)" id="workTntsh"
                            style="max-width: 175px;">
                            <mat-option *ngFor="let type of row.tntshList"
                                [value]="type.value">{{type.viewValue}}</mat-option>
                        </mat-select>
                    </td>
                </ng-container>
                <ng-container matColumnDef="suppntSpno">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 120px;">
                        供給地点特定番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.suppntSpno }}</td>
                </ng-container>
                <ng-container matColumnDef="sougouHisougou.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 55px;">被総合</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        {{row.sougouHisougou.aname}} </td>
                </ng-container>
                <ng-container matColumnDef="parentChild.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 55px;">親／子</th>
                    <td mat-cell *matCellDef="let row">
                        {{row.parentChild.aname}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="supplydestinationAddr">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 280px;">供給先住所
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.supplydestinationAddr }}</td>
                </ng-container>
                <ng-container matColumnDef="gastype.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 70px;">ガス種
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.gastype.aname }}</td>
                </ng-container>
                <ng-container matColumnDef="errorStr">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 280px;">エラー内容</th>
                    <td mat-cell *matCellDef="let row">{{ row.errorStr }}</td>
                </ng-container>
                <ng-container matColumnDef="supplystopResumeSts.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 90px;">供給停止再開<br>ステータス</th>
                    <td mat-cell *matCellDef="let row">{{ row.supplystopResumeSts.aname }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="supplyresumptionPlndate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 95px;">
                        供給再開<br>予定日</th>
                    <td mat-cell *matCellDef="let row">{{ row.supplyresumptionPlndate |
                        dateString}}<br>
                        {{ '(' + row.supplyresumptionYoteijikokuCode.aname + ')' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="forcedsuspensionTargetflag">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 45px;">強制</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        {{ row.forcedsuspensionTargetflag === '1'? '〇':'　' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="payCtrNo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 120px;">支払契約番号</th>
                    <td mat-cell *matCellDef="let row" style="min-width: 7.5em;">{{ row.payCtrNo }}</td>
                </ng-container>
                <ng-container matColumnDef="visitName">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 85px;">請求先名</th>
                    <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
            </table>
        </div>
        <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-card-actions class="btn_area_right">
                <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickRegist()"
                    [disabled]="!checkRegistButtonEnable()">登録</button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>